<template>
  <div>
    <header class="section pass-header" :style="{ background : success && (info.bg_color ? info.bg_color : '#f5d784')}">
      <div class="container">
        <div class="columns header is-vcentered is-hidden-mobile">
          <div class="column">
            <h1 class="title is-1 is-spaced">{{ info.title }}</h1>
            <p class="subtitle has-text-weight-medium">
              {{ info.desc }}
            </p>
          </div>
          <div class="column">
            <template v-if="info && info.video_url">
              <div class="image is-16by9">
                <div class="iframe-wrap" v-html="info.video_url"></div>
              </div>
            </template>
            <template v-else-if="info.image">
              <div class="image">
                <img alt="..." :src="info.image" />
              </div>
            </template>
          </div>
        </div>
        <div class="columns header is-hidden-tablet">
          <div class="column">
            <h1 class="title is-1 is-spaced has-text-white">
              Play Pass &amp; Punch Pass
            </h1>
            <p class="subtitle has-text-weight-medium has-text-white">
              {{ info.desc }}
            </p>
          </div>
        </div>
      </div>
    </header>
    <section class="section price">
      <div class="container">
        <div class="columns is-centered is-vcentered">
          <div class="column is-8-tablet">
            <div>
              <div
                class="notification is-danger is-light has-text-weight-medium mb-4"
              >
                <div class="ng-star-inserted">
                  You can now buy the punch pass online and pick it up at the
                  store. These punch passes are great for holiday gifts! 😊
                </div>
              </div>
            </div>
            <div>
              <table class="table is-striped is-hoverable is-fullwidth">
                <thead class="has-background-primary has-text-centered">
                  <tr>
                    <th scope="col" class="has-text-white">Age</th>
                    <th scope="col" id="head" class="has-text-white">0-2</th>
                    <th scope="col" id="head" class="has-text-white">3+</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in items" :key="index">
                    <th scope="row">{{ item.title }}</th>
                    <td>
                      {{ item.price1 }}
                      <!-- :href="item.buy"
                        target="_blank"
                        rel="noopener" -->
                      <!-- <a
                        v-if="item.sale_online == 1"
                        @click="buy(item, 1, index)"
                        class="is-primary is-underlined has-text-weight-medium"
                        >Buy</a
                      > -->
                      <el-button
                        v-if="item.sale_online == 1"
                        @click="buy(item, 1, index)"
                        class="is-primary is-underlined has-text-weight-medium red_btn"
                        :loading="item.loading"
                        >Buy</el-button
                      >
                    </td>
                    <td>
                      {{ item.price2 }}
                      <!-- <a
                        v-if="item.sale_online == 1"
                        @click="buy(item, 2, index)"
                        target="_blank"
                        class="is-primary is-underlined has-text-weight-medium"
                        >Buy</a
                      > -->
                      <el-button
                        v-if="item.sale_online == 1"
                        @click="buy(item, 2, index)"
                        class="is-primary is-underlined has-text-weight-medium red_btn"
                        :loading="item.loading1"
                        >Buy</el-button
                      >
                    </td>
                  </tr>
                  <tr
                    class="ng-star-inserted"
                    v-for="(item, index) in price_desc"
                    :key="`tr_${index}`"
                  >
                    <td colspan="3" class="has-text-justified">
                      <strong>{{ item.title }}:</strong> {{ item.desc }}.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { playPunchList, payInfo } from "@/server/api.js";
export default {
  components: {},
  data() {
    return {
      items: [],
      price_desc: [],
      info: {},
      success: false
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      try {
        const { status, data } = await playPunchList({});
        if (status == 0) {
          this.price_desc = data.price_desc;
          data.items.map((item) => (item.loading = false));
          this.items = data.items;
          this.info = data.info;
          this.success = true;
          setTimeout(() => {
            var iframe = document.getElementsByTagName("iframe");
            for (let i = 0; i <= iframe.length - 1; i++) {
              iframe[i].style.width = "100%";
              iframe[i].style.height = "100%";
            }
          }, 0);
        }
      } catch (error) {}
    },
    async buy(item, type, index) {
      var items = JSON.parse(JSON.stringify(this.items));
      items.map((citem, cindex) => {
        if (cindex == index) {
          if(type==1) {
            citem.loading = true;
          } else {
            citem.loading1 = true;
          }
        }
        return citem;
      });
      this.items = items;
      const { status, data } = await payInfo({
        product_type: 1,
        product_id: item.id,
        pay_way: type,
      });
      if (status === 0) {
        // window.open(data.pay_url);
        const a = document.createElement('a');
        a.href = data.pay_url;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        this.$message.error("获取失败");
      }
      var items = JSON.parse(JSON.stringify(this.items));
      items.map((citem, cindex) => {
        if (cindex == index) {
          if(type==1) {
            citem.loading = false;
          } else {
            citem.loading1 = false;
          }
        }
        return citem;
      });
      this.items = items;
    },
  },
};
</script>
<style scoped>
.pass-header {
  margin-top: 50px;
}
.hero-body,
.section {
  padding: 3rem 1.5rem;
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
.columns:not(:last-child) {
  margin-bottom: calc(1.5rem - 1.5rem);
}
.columns.is-vcentered {
  align-items: center;
}

.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
  box-sizing: border-box;
}
.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.block:not(:last-child),
.box:not(:last-child),
.breadcrumb:not(:last-child),
.content:not(:last-child),
.highlight:not(:last-child),
.level:not(:last-child),
.message:not(:last-child),
.notification:not(:last-child),
.pagination:not(:last-child),
.progress:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.tabs:not(:last-child),
.title:not(:last-child) {
  margin-bottom: 1.5rem;
}
.title.is-1 {
  font-size: 3rem;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.subtitle,
.title {
  word-break: break-word;
}

.has-text-weight-medium {
  font-weight: 500 !important;
}

img,
video {
  height: auto;
  max-width: 100%;
}
.image {
  display: block;
  position: relative;
  height: 340px;
}
.image img {
  display: block;
  height: 100%;
}

img {
  height: auto;
  max-width: 100%;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
.has-text-white {
  color: #fff !important;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.subtitle,
.title {
  word-break: break-word;
}
.columns.is-vcentered {
  align-items: center;
}
.columns.is-centered {
  justify-content: center;
}
.columns:last-child {
  margin-bottom: -1.5rem;
}
.notification {
  background-color: #f5f5f5;
  border-radius: 4px;
  position: relative;
  padding: 1.25rem 2.5rem 1.25rem 1.5rem;
}
.notification.is-danger.is-light {
  background-color: #fceeee;
  color: #bd2327;
}
.notification.is-danger {
  background-color: #de4c50;
  color: #fff;
}
.notification.is-light {
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.7);
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
.mb-4 {
  margin-bottom: 1rem !important;
}

.table {
  background-color: #fff;
  color: #363636;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
.table.is-fullwidth {
  width: 100%;
}
table thead {
  color: #fff;
  text-align: center;
}

.table thead {
  background-color: initial;
}
.has-text-centered {
  text-align: center !important;
}
.has-background-primary {
  background-color: #de4c50 !important;
}
.table td,
.table th {
  border: solid #dbdbdb;
  border-width: 0 0 1px;
  padding: 0.5em 0.75em;
  vertical-align: center;
}
.table th {
  color: #363636;
}

.table th:not([align]) {
  text-align: inherit;
}

.table thead td,
.table thead th {
  border-width: 0 0 2px;
  color: #363636;
}
table th:not([align]) {
  text-align: inherit;
}
.table tbody {
  background-color: initial;
}
table tr td {
  text-align: center;
  align-items: center;
}
strong {
  color: #363636;
  font-weight: 700;
}
a {
  color: #e55f61;
  cursor: pointer;
  text-decoration: none;
}
.is-underlined {
  text-decoration: underline;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
.has-text-justified {
  text-align: justify !important;
}
@media print, screen and (max-width: 768px) {
  .pass-header {
    background-image: url(../../assets/img/Kids-Jump.bdf66917305d3a34b885.png);
    background-color: rgba(0, 0, 0, 0.5);
    background-blend-mode: multiply;
    background-position: 50%;
    background-repeat: no-repeat;
  }
  .is-hidden-mobile {
    display: none !important;
  }
}
@media print, screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
  .is-hidden-tablet {
    display: none !important;
  }
  .column.is-8-tablet {
    flex: none;
    width: 66.6666666667%;
  }
}
@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}
.iframe-wrap {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.red_btn {
  padding: 0px;
  color: #e55f61;
  border: 0px;
  font-family: Quicksand, sans-serif;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/pricing/pass.vue